import { AppModule } from './app/app.module';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { platformBrowser } from '@angular/platform-browser';
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const msg = event.reason?.message || '';
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('error loading dynamically imported module')
    ) {
      window.location.reload();
    }
  });
}
platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));

